import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges,
    ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DynamicComponent, HisAuthService, HisUiService, HisNotificationService, HisConfirmationService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { INFORMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/information-dialog.component';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';
import { ResearchContract } from 'app/fs/res/common/model/finance/research-contract-classes';

import { BudgetSourceService } from 'app/fs/res/finance/service/budget-source/budget-source.service';
import { FinanceUtils } from 'app/fs/res/finance/utils/finance-utils';
import { BudgetSource } from 'app/fs/res/finance/model/budget-source/budget-source';

@Component( {
    selector: 'res-edit-right-of-use-right',
    templateUrl: './edit-right-of-use.component.html',
    providers: [ProviderManager.getComponentProvider(EditRightOfUseComponent)],
} )
export class EditRightOfUseComponent implements OnInit, OnChanges {
    @Input() researchContracts: ResearchContract[]; // ngModel
    @Input() infoAssignmentRightOfUse: string;
    @Input() dynamicComponent: DynamicComponent;
    @Output() researchContractChange: EventEmitter<ResearchContract[]> = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public filteredOptions: BudgetSource[];
    public selectedOption: BudgetSource;

    // all researchContracts without the dummy entries
    public filteredResearchContracts: ResearchContract[] = [];

    public dateFormat: string;

    private isEditMode = false;

    constructor( public auth: HisAuthService,
        private hisUiService: HisUiService,
        private confirmationService: HisConfirmationService,
        private notificationService: HisNotificationService,
        private budgetSourceService: BudgetSourceService ) {
    }

    /* Component ngOnInit */
    ngOnInit() {
        this.dateFormat = this.hisUiService.translate( 'common.dateFormat' );
    }

    ngOnChanges( changes: SimpleChanges ): void {
        if ( changes.researchContracts ) {
            this.filteredResearchContracts = FinanceUtils.getResearchContractsWithoutDummies( changes.researchContracts.currentValue );
        }
    }

    /**
     * completeMethod() implementation of <p-autoComplete> to filter inputs.
     *
     * @param event Event contains input value form select-box
     */
    completeMethod( event: { query: string } ) {
        this.budgetSourceService.getRightOfUseTypes( event.query ).subscribe( (budgetSourceOptions: BudgetSource[]) =>
            this.filteredOptions = budgetSourceOptions
        );
    }

    /**
     * onSelect() implementation of <p-autoComplete> to set funding-program for project.
     *
     * @param event select-box event element of object BudgetSource
     */
    onSelect( event: BudgetSource ) {
        // check if budgetSource already exists
        if ( !this.researchContracts.find( r => r.budgetSource.id === event.id ) ) {
            let researchContract = new ResearchContract();
            researchContract.budgetSource = event;
            researchContract.incomes = null;

            this.researchContractChange.emit( [...this.researchContracts, researchContract] );
            this.setIsEditMode( false );
        } else {
            this.notificationService.warnI18nRes( 'fs.res.common.finance.rightOfUseAlreadyAssigned' );
        }

        setTimeout( () => {
            this.selectedOption = null;
            return;
        } );
    }

    /* delete budgetSource from table */
    deleteBudgetSource( row: ResearchContract ) {
        if ( row.incomes == null || row.incomes.length <= 0 ) {
            let index = this.researchContracts.indexOf( row );
            this.researchContracts.splice( index, 1 );
            this.researchContracts = [...this.researchContracts];
            this.researchContractChange.emit( this.researchContracts );
        } else {
            this.confirmationService.confirm( {
                key: INFORMATION_PDIALOG_KEY,
                message: this.hisUiService.translate( 'fs.res.common.researchContract.cannotDelete.rightOfUse' ),
            } );
        }
    }

    public getBudgetSourceAndOrganization( researchContract: ResearchContract ) {
        return researchContract.budgetSource.defaulttext + ' (' + (researchContract.budgetSource.researchPartner
            ? researchContract.budgetSource.researchPartner.defaulttext : researchContract.budgetSource.organization
                ? researchContract.budgetSource.organization.defaulttext : '') + ')';
    }

    /* getter */
    getIsEditMode(): boolean {
        return this.isEditMode;
    }

    /* setter */
    setIsEditMode( visablity: boolean ) {
        this.isEditMode = visablity;
    }
}
